import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Grid } from "@mui/material";

const HomeImageCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const images = [
    "/images/homeScreenImage2.png",
    "/images/homeScreenImage.png",
    // "/images/image.png"
  ];

  return (
   <Grid
                       item
                       xs={12}
                       sm={6}
                       md={4}
                       sx={{
                          
                           marginTop:'100px'
                       }}
                   >
      <Slider {...settings}>
        {images.map((src, index) => (
          <div key={index}>
            <img
              src={src}
              alt={`Slide ${index + 1}`}
              style={{
                width: "100%",
                height: "480px",
                objectFit: "contain",
              }}
            />
          </div>
        ))}
      </Slider>
    </Grid>
  );
};

export default HomeImageCarousel;
